<template>
  <hm-content title="促销列表">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="addActivity"
          >创建促销</el-button
        >
      </div>
      <div>
        <el-date-picker
          v-model="date"
          type="daterange"
          align="right"
          start-placeholder="促销开始时间"
          end-placeholder="促销结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-select
          clearable
          v-model="promotionCode"
          placeholder="促销类型"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in activityChildCategoryList"
            :key="item.promotionCode"
            :label="item.typeName"
            :value="item.promotionCode"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="auditState"
          placeholder="审核状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="待提交" value="wait_commit"></el-option>
          <el-option label="待审核" value="wait_audit"></el-option>
          <!-- <el-option label="审核中"
                     value="in_audit"></el-option> -->
          <el-option label="审核通过" value="audit_pass"></el-option>
          <el-option label="已驳回" value="reject"></el-option>
        </el-select>
        <el-select
          clearable
          v-model="enabledState"
          placeholder="促销状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="上线" value="enable"></el-option>
          <el-option label="下线" value="disabled"></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="promotionName"
          placeholder="输入促销名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="keyword"
          placeholder="请输入 条码 / 货号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="flex flex-between">
        <div class="hm-radio-group">
          <el-radio-group v-model="timeStatus" size="small" @change="switchTab">
            <el-radio-button label="all"
              >全部({{ activeListCount.all }})</el-radio-button
            >
            <el-radio-button label="notStarted"
              >未开始({{ activeListCount.notStarted }})</el-radio-button
            >
            <el-radio-button label="running"
              >进行中({{ activeListCount.running }})</el-radio-button
            >
            <el-radio-button label="end"
              >已结束({{ activeListCount.end }})</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="flex">
          <div class="flex item-center mr20" @click="openBasicSetting">
            <span class="delete-icon hmicon icon-xitong"></span>
            基础设置
          </div>          
          <div @click="batchSetting" class="flex item-center pointer">
            <span class="delete-icon hmicon icon-xitong"></span>
            批量上/下线
          </div>
        </div>
      </div>

      <el-table
        stripe
        :data="activityList.records"
        style="width: 100%"
        id="table"
        size="small"
        @selection-change="getChecked"
        border
      >
        <el-table-column
          type="selection"
          :selectable="checkSelectable"
        ></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="促销类型">
          <template slot-scope="scope">
            <div class="table-status flex item-center">
              <span
                class="status success-bg"
                v-show="scope.row.timeStatus === 'running'"
              ></span>
              <span
                class="status gray-bg"
                v-show="scope.row.timeStatus === 'notStarted'"
              ></span>
              <span
                class="status danger-bg"
                v-show="scope.row.timeStatus === 'end'"
              ></span>
              <span class="flex flex-1 flex-start">{{
                scope.row.typeName
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="promotionName"
          label="促销名称"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.promotionName"
              placement="top"
            >
              <div class="flex item-center">
                <span class="pos" v-if="scope.row.createMode">
                  p
                </span>
                <span class="time flex-1 text-overflow">
                  {{ scope.row.promotionName }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="促销层级">
          <template slot-scope="scope">
            <div v-if="scope.row.pasLevel">{{ scope.row.pasLevel }}级促销</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="300px"
          prop="startDateFormat"
          label="促销时间"
        >
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.startDate }}至{{ scope.row.endDate }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverGuider"
          label="参与门店"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.outLet.join(',')"
              placement="top"
            >
              <div class="text-overflow">
                <span v-for="(v, i) in scope.row.outLet" :key="i">
                  {{ v }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverGuider"
          label="销售渠道"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.platform.join(',')"
              placement="top"
            >
              <div class="text-overflow">
                <span v-for="(v, i) in scope.row.platform" :key="i">
                  {{ v }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="introText"
          label="促销备注"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
            <!-- <el-tooltip class="item" content="编辑" placement="top">
              <div
                class="pointer mr10"
                @click="edit(scope.row)"
              >
                <span class="hmicon icon-bianji blue"></span>
              </div>
            </el-tooltip>          -->
            <el-tooltip
              class="item"
              :content="scope.row.introText"
              placement="top"
            >
              <span class="text-overflow">
                {{ scope.row.introText }}
              </span>
            </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusFormat"
          label="促销标签"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.labels.join(',')"
              placement="top"
            >
              <div class="text-overflow">
                <span v-for="(v, i) in scope.row.labels" :key="i">
                  {{ v }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="审核状态">
          <template slot-scope="scope">
            <span
              class="status blue"
              v-show="scope.row.auditState === 'wait_commit'"
              >待提交</span
            >
            <span
              class="status blue"
              v-show="scope.row.auditState === 'wait_audit'"
              >待审核</span
            >
            <!-- <span class="status blue"
                  :class="scope.row.auditState"
                  v-show="scope.row.auditState === 'in_audit'">审核中</span> -->
            <span
              class="status success"
              :class="scope.row.auditState"
              v-show="scope.row.auditState === 'audit_pass'"
              >审核通过</span
            >
            <span
              class="status danger"
              :class="scope.row.auditState"
              v-show="scope.row.auditState === 'reject'"
              >已驳回</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="促销状态"
        >
          <template slot-scope="scope">
            <span
              class="status danger"
              v-show="scope.row.enabledState === 'disabled'"
              >下线</span
            >
            <span
              class="status success"
              v-show="scope.row.enabledState === 'enable'"
              >上线</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="200"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip
                class="item"
                content="统计"
                placement="top"
                v-show="scope.row.auditState === 'audit_pass'"
              >
                <div class="pointer mr10" @click="statistics(scope.row)">
                  <span class="hmicon icon-zhexiantu blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer mr10" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="编辑促销名称和备注" placement="top">
                <div
                  class="pointer mr10"
                  @click="editIntroText(scope.row)"
                >
                  <span class="hmicon icon-shuru blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="编辑" placement="top">
                <div
                  class="pointer mr10"
                  @click="edit(scope.row)"
                  v-show="scope.row.auditState !== 'audit_pass'"
                >
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="复制" placement="top">
                <div class="pointer mr10" @click="copy(scope.row)">
                  <span class="hmicon icon-fuzhi blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip
                v-show="
                  scope.row.auditState === 'audit_pass' &&
                    scope.row.enabledState === 'disabled'
                "
                class="item"
                content="上线"
                placement="top"
              >
                <div
                  class="pointer mr10"
                  @click="switchAuditState(scope.row.id, 'enable')"
                >
                  <span class="hmicon icon-shangxian blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip
                v-show="
                  scope.row.auditState === 'audit_pass' &&
                    scope.row.enabledState === 'enable'
                "
                class="item"
                content="下线"
                placement="top"
              >
                <div
                  class="pointer mr10"
                  @click="switchAuditState(scope.row.id, 'disabled')"
                  title="下线"
                >
                  <span class="hmicon icon-xiaxian blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div
                  class="pointer mr10"
                  @click="remove(scope.row)"
                  v-show="
                    scope.row.auditState !== 'audit_pass' ||
                      (scope.row.auditState === 'audit_pass' &&
                        scope.row.enabledState === 'disabled')
                  "
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <hm-status />
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="activityList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      title="批量操作"
      :visible.sync="batchDialogVisible"
      width="500px"
    >
      <div slot="title">
        <span class="mr10">批量设置</span>
        <span class="form-item-tip">已选活动数量{{ checkedRow.length }}个</span>
      </div>
      <div class="flex tabs">
        <el-tabs tab-position="left" v-model="tabType">
          <el-tab-pane label="批量上/下线" name="akb">
            <div
              v-if="tabType === 'akb'"
              class="flex flex-center"
              style="marginLeft:30px;marginTop:5px"
            >
              <el-button
                type="text"
                size="small"
                class="success"
                @click="batchOperate('enable')"
                >上线</el-button
              >
              <el-button
                class="danger"
                type="text"
                size="small"
                @click="batchOperate('disabled')"
                >下线</el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑促销备注"
      :visible.sync="introTextDialogVisible"
      width="500px"
       @close="close"
    >
      <div slot="title">
        <span class="mr10">编辑促销名称和备注</span>
      </div>
      <div class="flex tabs">
        <el-form
          :model="basicConfigInfo"
          ref="basicConfigInfo"
          label-width="130px"
        >
        <el-form-item label="促销名称：" prop="promotionName">
          <el-input
            type="text"
            v-model.trim="basicConfigInfo.promotionName"
            clearable
            placeholder="请输入促销名称,最多30个字符"
            size="small"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="促销备注：" prop="newpromotionName">
          <el-input
            maxlength="240"
            v-model="basicConfigInfo.introText"
            placeholder="请输入促销备注"
            type="textarea"
          ></el-input>
        </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="confirm">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="基础设置"
      :visible.sync="basicSettingDialogVisible"
      width="700px"
      @close="basicSettingDialogVisible = false"
    >
      <div class="flex item-center mr20 setting-item" v-if="predictSwitch==='open'">
        <div class="pointer" @click="openDialogPredictPrice">
          <span class="setting-title item-center">小程序展示预估价设置</span>
          <el-switch
            v-model="predictPriceState"
            active-text=""
            inactive-text=""
            active-color="#13ce66"
            active-value="open"
            inactive-value="close"
            :disabled="true"
          ></el-switch>
          <div class="setting-tips">开启后列表页和商品详情展示通过促销计算出的预估到手价</div>
        </div>        
      </div>
      <div class="flex item-center mr20 setting-item">
        <div class="pointer" @click="changeSpecialTipsState">
          <span class="setting-title">特价详情展示限时结束</span>
          <el-switch
            v-model="specialTipsState"
            active-text=""
            inactive-text=""
            active-color="#13ce66"
            active-value="open"
            inactive-value="close"
          ></el-switch>
          <div class="setting-tips">开启后特价活动详情展示限时结束信息</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">        
        <el-button size="small" @click="basicSettingDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="小程序展示预估价"
      :visible.sync="predictPriceDialogVisible"
      width="950px"
      @close="closeDialogPredictPrice"
    >
      <div slot="futurePricesTitle">
        <span class="mr10">小程序展示预估价</span>
      </div>
      <div class="flex futurePrices">
        <img :src="activityList_01" class="img" alt />
        <div class="right">
          <div class="h2">商品预估价</div>
          <div class="h3">• 开启后小程序的商品详情页、列表页展示预估到手价，如左图</div>
          <div class="h3">• 预估价是根据满减、满折、组合价活动计算最高优惠而来</div>
          <div class="h3">• 当一个商品多个规格价格时，不显示预估价</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="confirmPredictPrice">确 认</el-button>
        <el-button size="small" @click="closeDialogPredictPrice">取 消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import HmStatus from "@/components/HmStatus";
import moment from "moment";
import { mapGetters } from "vuex";
import { removeCookie, setCookie, getCookie } from "@/utils/utils";
export default {
  components: { HmStatus },
  data() {
    return {
      tabType: "akb",
      batchDialogVisible: false,
      introTextDialogVisible: false,
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "all",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      keyword: "",
      enabledState: "",
      auditState: "",
      isOutputing: false,
      checkedRow: [],
      basicConfigInfo:{
        id: "",
        promotionCode: "",
        promotionName: "",
        introText: "",
      },
      parentId:"",
      storeCode: "",
      predictPriceDialogVisible: false,
      activityList_01: "https://imgcdn.hemiao100.com/hemiaoBase/activity/activityList_01.png",
      predictPriceState: "close",
      predictSwitch: "close",
      basicSettingDialogVisible: false,
      specialTipsState: "open"
    };
  },
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    const echoParams = getCookie({ key: "ACTIVITYlIST", type: "session" });
    if (echoParams) {
      for (let key in echoParams) {
        if (this.hasOwnProperty(key)) {
          this[key] = echoParams[key];
        }
      }
      if (echoParams.startDate && echoParams.endDate) {
        this.date = [
          new Date(echoParams.startDate),
          new Date(echoParams.endDate)
        ];
      }
      this.currentPage = echoParams.pageNo;
    }    
  },
  mounted() {
    this.getParamsCookie();
    this.queryStoreConfigPredictSwitch();
    this.queryStoreConfigPredictPrice();
    this.queryStoreConfigSpecialTips();
    this.queryList();
    this.$store.dispatch("queryActivityCategoryList");
  },
  computed: mapGetters([
    "activityList",
    "appointmentListInfo",
    "allActivityList",
    "serviceList",
    "storeList",
    "activityCategoryList",
    "activeListCount"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    },
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    async batchOperate(enabledState) {
      const { code } = await this.$store.dispatch("actBatchOperate", {
        basicInfoIdList: this.checkedRow,
        enabledState
      });
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.batchDialogVisible = false;
        this.checkedRow = [];
        this.queryList();
      }
    },
    async batchSetting() {
      if (this.checkedRow.length) {
        this.batchDialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    checkSelectable(row) {
      if (row.auditState === "audit_pass") {
        return true;
      }
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.id);
    },
    handleAdd() {},
    statistics(row) {
      console.log("row: ", row);
      this.$router.push({
        name: "ActivityStatistics",
        query: {
          promotionCode: row.promotionCode,
          promotionName: row.promotionName,
          id: row.id
        }
      });
    },
    toDetails(row) {
      this.$router.push({
        name: "ActivityDetails",
        query: {
          id: row.id,
          type: row.auditState,
          parentId: row.promotionCode.split("-")[0],
          mode: "view"
        }
      });
    },
    edit(row) {
      this.$router.push({
        name: "CreatActivity",
        query: {
          type: "edit"
        }
      });
      removeCookie({ key: "STEP" });
      const steps = {};
      steps.step1 = {
        parentId: row.promotionCode.split("-")[0],
        childId: row.promotionCode.split("-")[1],
        id: row.id
      };
      setCookie({
        key: "STEP",
        data: steps
      });
    },
    copy(row) {
      this.$router.push({
        name: "CreatActivity",
        query: {
          type: "edit",
          subType: "copy"
        }
      });
      removeCookie({ key: "STEP" });
      const steps = {};
      steps.step1 = {
        parentId: row.promotionCode.split("-")[0],
        childId: row.promotionCode.split("-")[1],
        id: row.id
      };
      setCookie({
        key: "STEP",
        data: steps
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(() => {
            const list = this.allActivityList;
            const tHeader = [
              "促销类型",
              "促销名称",
              "促销时间",
              "参与门店",
              "促销备注",
              "促销标签",
              "审核状态",
              "促销状态"
            ];
            const filterVal = [
              "typeName",
              "promotionName",
              "activityDateTime",
              "outLet",
              "introText",
              "labelsFormat",
              "auditStateFormat",
              "enabledStateFormat"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "促销活动列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteCurrentRowActivity", {
            id: row.id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      this.setParamsCookie();
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        startDate: this.date ? this.date[0] : null,
        endDate: this.date ? this.date[1] : null,
        promotionCode: this.promotionCode,
        auditState: this.auditState,
        enabledState: this.enabledState,
        promotionName: this.promotionName,
        keyword: this.keyword,
        timeStatus: this.timeStatus
      };
      setCookie({
        key: "ACTIVITYlIST",
        type: "session",
        data: params
      });
      return this.$store.dispatch("queryActivityList", params);
    },
    setParamsCookie() {
      let searchCondition = {
        date: this.date,
        promotionCode: this.promotionCode,
        auditState: this.auditState,
        enabledState: this.enabledState,
        promotionName: this.promotionName,
        keyword: this.keyword,
        timeStatus: this.timeStatus
      };
      setCookie({
        key: "activityListParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "activityListParams", type: "session" });
      if (prams) {
        this.date = prams.date;
        this.promotionCode = prams.promotionCode;
        this.auditState = prams.auditState;
        this.enabledState = prams.enabledState;
        this.promotionName = prams.promotionName;
        this.keyword = prams.keyword;
        this.timeStatus = prams.timeStatus;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      return this.$store.dispatch("queryAllActivityList", {
        pageSize: 999999,
        pageNo: this.currentPage,
        startDate: this.date ? this.date[0] : null,
        endDate: this.date ? this.date[1] : null,
        promotionCode: this.promotionCode,
        auditState: this.auditState,
        enabledState: this.enabledState,
        promotionName: this.promotionName,
        keyword: this.keyword,
        timeStatus: this.timeStatus
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    editIntroText(row){
      console.log("row:",row);
      this.basicConfigInfo.id = row.id;
      this.basicConfigInfo.promotionCode = row.promotionCode;
      this.basicConfigInfo.promotionName = row.promotionName;
      this.basicConfigInfo.introText = row.introText;
      this.parentId = row.promotionCode.split("-")[0];
      console.log("this.parentId:",this.parentId);
      this.introTextDialogVisible = true;
    },
    confirm() {
      let params;
      params = this.basicConfigInfo;
      this.$store.dispatch("editAttr", params).then(() => {
        this.introTextDialogVisible = false;
        this.queryList();
      });
    },
    close() {
      this.introTextDialogVisible = false;
    },
    openDialogPredictPrice(){
      if(this.predictPriceState==="close"){
        this.predictPriceDialogVisible = true;
      }else{
        this.predictPriceState = "close";
        this.editStoreConfigPredictPrice();
      }
    },
    closeDialogPredictPrice(){
      this.predictPriceDialogVisible = false;
    },
    confirmPredictPrice(){
      this.predictPriceState = "open";
      this.editStoreConfigPredictPrice();
    },
    async queryStoreConfigPredictPrice(){
      const { result } = await this.$store.dispatch("queryStoreConfigAll", {
        storeCode: this.storeCode,
        code:"predictPrice",
      });
      console.log("result:",result);
      if(result.value){
        this.predictPriceState = result.value;
      }else{
        this.addStoreConfigPredictPrice();
      }
    },
    async addStoreConfigPredictPrice(){
      const { result } = await this.$store.dispatch("addStoreConfigAll", {
        storeCode: this.storeCode,
        code:"predictPrice",
        name:"新增促销预估价",
        value: this.predictPriceState,
      });
      console.log("result:",result);
    },
    async editStoreConfigPredictPrice(){      
      const { result } = await this.$store.dispatch("editStoreConfigAll", {
        storeCode: this.storeCode,
        code:"predictPrice",
        name:"编辑促销预估价",
        value: this.predictPriceState,
      });
      this.$message({
        type: "success",
        message: "设置成功"
      });
      this.queryStoreConfigPredictPrice();
      this.predictPriceDialogVisible = false;
    },
    async queryStoreConfigPredictSwitch(){
      const { result } = await this.$store.dispatch("queryStoreConfigAll", {
        storeCode: this.storeCode,
        code:"predictSwitch",
      });
      console.log("result:",result);
      if(result.value){
        this.predictSwitch = result.value;
      }
    },
    openBasicSetting(){      
      this.basicSettingDialogVisible = true;
    },
    changeSpecialTipsState(){
      this.editStoreConfigSpecialTips();
    },
    async addStoreConfigSpecialTips(){
      const { result } = await this.$store.dispatch("addStoreConfigAll", {
        storeCode: this.storeCode,
        code:"specialTips",
        name:"新增促销特价标签",
        value: this.specialTipsState,
      });
      console.log("result:",result);
    },
    async editStoreConfigSpecialTips(){      
      const { result } = await this.$store.dispatch("editStoreConfigAll", {
        storeCode: this.storeCode,
        code:"specialTips",
        name:"编辑促销特价标签",
        value: this.specialTipsState,
      });
      this.$message({
        type: "success",
        message: "设置成功"
      });
      this.queryStoreConfigSpecialTips();
    },
    async queryStoreConfigSpecialTips(){
      const { result } = await this.$store.dispatch("queryStoreConfigAll", {
        storeCode: this.storeCode,
        code:"specialTips",
      });
      console.log("result:",result);
      if(result.value){
        this.specialTipsState = result.value;
      }else{
        this.addStoreConfigSpecialTips();
      }
    },
  }
};
</script>

<style scoped lang="scss">
// .tabs {
//   .first-tip {
//     padding-left: 30px;
//     margin-bottom: 20px;
//     .title {
//       padding-left: 0;
//     }
//   }
//   .title {
//     color: #222222;
//     padding-left: 10px;
//   }
//   .form-item-tip {
//     font-size: 12px;
//   }
// }
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}

.pos {
  margin-right: 5px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background: #e50163;
  color: #fff;
}
.futurePrices{
  .img{
    width: 360px;
    display: block;
  }
  .right{
    padding-left: 50px;
    .h2{
      padding-top: 40px;
      font-size: 25px;
      color: #222222;
      line-height: 30px;
      padding-bottom: 14px;
    }
    .h3{
      font-size: 16px;
      color: #222222;
      line-height: 19px;
      padding: 5px 0;
    }
  }
}
.futurePricesTitle{
  font-size: 16px;
  font-weight: blod;
  color: #222222;
  line-height: 19px;
}
.setting-item{
  .setting-title{
    width: 250px;
    text-align: right;
    display: inline-block;
    font-size: 18px;
    margin-right: 20px;
    padding: 20px 0;
  }
  .setting-tips{
    padding:0 0 0 270px;
  }
}
</style>
<style lang="scss">
    .el-tooltip__popper{max-width:15%}
</style>
